import lang from '../../lib/language';

import Login1Image from '../../assets/img/login1.png';
import Login2Image from '../../assets/img/login2.png';
import Login3Image from '../../assets/img/login3.png';

type OptionType = {
  title: string;
  description?: string;
  icon: string;
}

export const getCarouselOptions = (): OptionType[] => {
  const options: OptionType[] = [];
  options.push({
    title: lang.aceLoginTitle1(),
    icon: Login1Image,
  });

  options.push({
    title: lang.aceLoginTitle2(),
    icon: Login2Image,
  });

  options.push({
    title: lang.aceLoginTitle3(),
    icon: Login3Image,
  });

  return options;
};
